import { render, staticRenderFns } from "./backPrice.vue?vue&type=template&id=fc78d8ca&scoped=true&"
import script from "./backPrice.vue?vue&type=script&lang=js&"
export * from "./backPrice.vue?vue&type=script&lang=js&"
import style0 from "./backPrice.vue?vue&type=style&index=0&id=fc78d8ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc78d8ca",
  null
  
)

export default component.exports